import * as React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { Autocomplete, Box, TextField, FormControl } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { EditableTable } from '../../../subs/EditableTable';
import { Workshop, getWorkshops, getWorkshopInterfaces } from '../../../types/Workshop';
import { WorkshopInterface } from '../../../types/WorkshopInterface';

import { AlertProps } from '@mui/material/Alert';
import { useSnackbar } from '../../../../contexts/SnackBarContext';

export const WorkshopInterfacesAdminView = () => {
    const { showSnackbar } = useSnackbar();
    const [workshops, setWorkshops] = React.useState<Workshop[]>([]);
    const [workshop, setWorkshop] = React.useState<Workshop>();
    const [allData, setallData] = React.useState<WorkshopInterface[]>([]);

    const showUserFeedback = React.useCallback((msg: string | null, severity: AlertProps['severity'] = 'error') => {
        msg && showSnackbar(msg, severity);
    }, [showSnackbar]);

    React.useEffect(() => {
        const fetchAllWorkshops = async () => {
            const allworkshopsResponse = await getWorkshops(new AbortController());
            if (allworkshopsResponse.failed) {
                showUserFeedback(allworkshopsResponse.errorText);
                return;
            }
            setWorkshops(allworkshopsResponse.result);
        }
        fetchAllWorkshops();
    }, [showUserFeedback]);

    React.useEffect(() => {
        const fetchAllWorkshopInterfaces = async () => {
            if (workshop === undefined || workshop.id === 0) return;
            const wsIfaceResponse = await getWorkshopInterfaces(workshop.id, new AbortController());
            if (wsIfaceResponse.failed) {
                showUserFeedback(wsIfaceResponse.errorText);
                return;
            }
            setallData(wsIfaceResponse.result);
        }
        fetchAllWorkshopInterfaces();
    }, [workshop, showUserFeedback]);

    const columns: GridColDef[] = [
        {
            field: 'workshopId',
            headerName: 'Workshop ID',
            flex: 2
        },
        {
            field: 'interfaceId',
            headerName: 'Interface ID',
            flex: 1,
        },
    ];

    return <React.Fragment >
        <Grid size={6} paddingBottom={10}>
            <FormControl required fullWidth>
                <Autocomplete id='ac-wsOptions' options={workshops.map(w => w.name)}
                    value={workshop ? workshop.name : ''}
                    onChange={(e, value) => setWorkshop(workshops.find(w => w.name === value))}
                    renderInput={(params) =>
                        <TextField name='wsOptions' multiline
                            {...params}
                            label={"Workshop"}
                            sx={{
                                '& .MuiOutlinedInput-root fieldset': {
                                    borderColor: 'divider',
                                },
                                '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                                    borderColor: 'divider',
                                },
                            }}
                        />
                    }
                />
            </FormControl>
        </Grid>
        {
            workshop &&
            <Box sx={{ flexGrow: 1, width: "100%" }} style={{ overflow: 'auto' }}>
                <EditableTable
                    columns={columns}
                    rows={allData}
                    setAllRows={setallData}
                />
            </Box>
        }
    </React.Fragment >
}